import { useEffect, useImperativeHandle, useMemo, useRef, useState } from 'react';
import debounce from 'react-utils/debounce';
import { PulserOverlay } from '../pulser/PulserOverlay';
export const usePulserContainer = popoverAnchor => {
  const [pulserContainer, setPulserContainer] = useState();
  useEffect(() => {
    const floatingContainer = popoverAnchor === null || popoverAnchor === void 0 ? void 0 : popoverAnchor.closest('[id^="uiopenpopup-"]');
    if (!(floatingContainer !== null && floatingContainer !== void 0 && floatingContainer.parentNode)) {
      return undefined;
    }

    // Insert pulser dom before tour popover for making popover be above pulser overlay
    const pulserElement = document.createElement('div');
    pulserElement.id = `pulser-for-${floatingContainer.id}`;
    floatingContainer.parentNode.insertBefore(pulserElement, floatingContainer);
    setPulserContainer(pulserElement);
    return () => {
      if (pulserElement.parentNode) {
        pulserElement.parentNode.removeChild(pulserElement);
      }
      setPulserContainer(undefined);
    };
  }, [popoverAnchor]);
  return pulserContainer;
};
export const usePulserOverlay = pulserRef => {
  const pulserOverlayRef = useRef(new PulserOverlay());
  const [overlayPath, setOverlayPath] = useState(pulserOverlayRef.current.overlayPath);
  const debouncedSetOverlayPath = useMemo(() => {
    return debounce(() => {
      setOverlayPath(pulserOverlayRef.current.overlayPath);
    }, 5);
  }, []);

  // expose addPulserPathToOverlay to pulser spotlight component
  // recalculate transparent holes in pulser overlay
  useImperativeHandle(pulserRef, () => ({
    repositionPulserOverlay: (pulserPath, oldPulserPath) => {
      pulserOverlayRef.current.generateOverlayPath(pulserPath, oldPulserPath);
      debouncedSetOverlayPath();
    }
  }), [debouncedSetOverlayPath]);
  return overlayPath;
};